module.exports = __webpack_public_path__ + "img/bowel-cancer-leaflet.f2795a07.jpg";